export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

export function getToken() {
    return localStorage.getItem("paroles_agents_token");
}

export function authHeaders() {
    return {Authorization: `Bearer ${getToken()}`};
}

export function jsonHeaders() {
    return {"Content-Type": "application/json", ...authHeaders()};
}

// Endpoints où un 401 signifie "identifiants incorrects" et non "session expirée" : /login n'a
// pas encore de session à expirer, et /change-password peut renvoyer 401 pour un mauvais ancien
// mot de passe alors qu'un token valide est déjà présent. Le guard ne doit pas s'y déclencher,
// sinon l'agent est déconnecté et la page recharge avant que le message d'erreur ne s'affiche.
const AUTH_ENDPOINTS_EXEMPT_FROM_GUARD = ["/login", "/change-password"];

// Le backend renvoie 401 quand le jeton est manquant, invalide ou expiré (distinct des 403
// "rôle/appartenance insuffisants"). On intercepte ces 401 pour déconnecter l'agent au lieu de
// laisser l'écran afficher une session qui n'existe plus côté serveur.
export function installSessionExpiryGuard() {
    if (window.fetch.__sessionExpiryGuardInstalled) return;

    const originalFetch = window.fetch.bind(window);
    let expiring = false;
    const guardedFetch = async (...args) => {
        const response = await originalFetch(...args);
        const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
        const isExemptAuthEndpoint = url && AUTH_ENDPOINTS_EXEMPT_FROM_GUARD.some(path => url === `${API_URL}${path}`);
        if (!expiring && response.status === 401 && url && url.startsWith(API_URL) && !isExemptAuthEndpoint && getToken()) {
            expiring = true;
            localStorage.removeItem("paroles_agents_token");
            localStorage.removeItem("paroles_agents_user");
            window.location.reload();
        }
        return response;
    };
    guardedFetch.__sessionExpiryGuardInstalled = true;
    window.fetch = guardedFetch;
}
